var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Most Recent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24981 -1357C-24981 -1577.91 -24801.9 -1757 -24581 -1757H11120C11340.9 -1757 11520 -1577.91 11520 -1357V5477C11520 5697.91 11340.9 5877 11120 5877H-24581C-24801.9 5877 -24981 5697.91 -24981 5477V-1357Z",
    fill: "#5FA66C",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24581 -1757V-1756H11120V-1757V-1758H-24581V-1757ZM11520 -1357H11519V5477H11520H11521V-1357H11520ZM11120 5877V5876H-24581V5877V5878H11120V5877ZM-24981 5477H-24980V-1357H-24981H-24982V5477H-24981ZM-24581 5877V5876C-24801.4 5876 -24980 5697.36 -24980 5477H-24981H-24982C-24982 5698.47 -24802.5 5878 -24581 5878V5877ZM11520 5477H11519C11519 5697.36 11340.4 5876 11120 5876V5877V5878C11341.5 5878 11521 5698.47 11521 5477H11520ZM11120 -1757V-1756C11340.4 -1756 11519 -1577.36 11519 -1357H11520H11521C11521 -1578.47 11341.5 -1758 11120 -1758V-1757ZM-24581 -1757V-1758C-24802.5 -1758 -24982 -1578.47 -24982 -1357H-24981H-24980C-24980 -1577.36 -24801.4 -1756 -24581 -1756V-1757Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Site Based New Config",
    clipPath: "url(#clip0_3_9616)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1203,
    transform: "translate(-182 -611)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sidebar Background",
    d: "M-41 -139H555V570H-35C-38.3137 570 -41 567.314 -41 564V-139Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Main Background",
    x: -41.5,
    y: -178.5,
    width: 1747,
    height: 749,
    rx: 7.5,
    stroke: "#191FDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 13.3333L11.5556 9.77778L10.3111 8.53333L8.88889 9.95556V6.22222H7.11111V9.95556L5.68889 8.53333L4.44444 9.77778L8 13.3333ZM1.77778 4.44444V14.2222H14.2222V4.44444H1.77778ZM1.77778 16C1.28889 16 0.87037 15.8259 0.522222 15.4778C0.174074 15.1296 0 14.7111 0 14.2222V3.13333C0 2.92593 0.0333333 2.72593 0.1 2.53333C0.166667 2.34074 0.266667 2.16296 0.4 2L1.51111 0.644444C1.67407 0.437037 1.87778 0.277778 2.12222 0.166667C2.36667 0.0555556 2.62222 0 2.88889 0H13.1111C13.3778 0 13.6333 0.0555556 13.8778 0.166667C14.1222 0.277778 14.3259 0.437037 14.4889 0.644444L15.6 2C15.7333 2.16296 15.8333 2.34074 15.9 2.53333C15.9667 2.72593 16 2.92593 16 3.13333V14.2222C16 14.7111 15.8259 15.1296 15.4778 15.4778C15.1296 15.8259 14.7111 16 14.2222 16H1.77778ZM2.13333 2.66667H13.8667L13.1111 1.77778H2.88889L2.13333 2.66667Z",
    fill: "#FDB523"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 11",
    d: "M38.4645 783.536C40.4171 785.488 43.583 785.488 45.5356 783.536L77.3554 751.716C79.308 749.763 79.308 746.597 77.3554 744.645C75.4028 742.692 72.2369 742.692 70.2843 744.645L42 772.929L13.7158 744.645C11.7631 742.692 8.59732 742.692 6.6447 744.645C4.69208 746.597 4.69208 749.763 6.6447 751.716L38.4645 783.536ZM42 -103L37 -103L37 780L42 780L47 780L47 -103L42 -103Z",
    fill: "#E21515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_9616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1203,
    fill: "white",
    transform: "translate(-182 -611)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.d86e6f001aab83eb275e7a0da11f173d.svg";
export { ForwardRef as ReactComponent };